<template>
  <div>
    <div class="deploy-versions-container">
      <div>
        <label for="searchByTicket">ticket</label>
        <input
          type="text"
          placeholder=" 請輸入要查詢的ticket"
          @input="handleInput(searchTicket)"
          style="margin-left: 5px"
          v-model="searchTicket"
        />
        <button
          style="margin-left: 10px"
          @click.prevent="searchByTicket"
          :disabled="!isTicketValid"
        >
          查詢
        </button>
        <span style="padding-left: 10px; color: red">{{ ticketErrorMsg }}</span>
      </div>
      <br />
      <div class="deploy-version-item header">
        <div class="deploy-version">版號</div>
        <div class="deploy-version-changes">包含JIRA單</div>
        <div class="deploy-action">上版操作</div>
      </div>
      <div
        v-for="data in deployableVersions"
        :key="'deploy-version-item-' + data.version"
        class="deploy-version-item"
      >
        <div class="deploy-version">{{ data.version }}</div>
        <div class="deploy-version-changes">
          <div
            v-for="ticket in data.tickets"
            :key="'version-change-' + ticket"
            class="version-change-ticket"
          >
            <a
              target="_blank"
              :href="'https://innotech.atlassian.net/browse/' + ticket"
              >{{ ticket }}</a
            >
          </div>
        </div>
        <div class="deploy-action">
          <button
            type="button"
            class="deploy-btn"
            @click="onDeploy(data.version)"
            :disabled="data.version === currentVersion"
          >
            {{ data.version === currentVersion ? "當版" : "上版" }}
          </button>
        </div>
      </div>
    </div>
    <modal
      name="deploy"
      :styles="{ padding: '10px' }"
      height="200px"
      @before-close="onModalClose"
    >
      <div class="modal-container">
        <div class="modal-title">確認上版</div>

        <div class="modal-body">
          <div class="confirm-deploy-title">
            是否確認上版版號：{{ selectedVersion }} ？
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="button cancel-btn" @click="cancel">
            取消
          </button>
          <button
            type="button"
            class="button confirm-btn"
            @click="confirmDeploy"
          >
            確認
          </button>
        </div>
      </div>
    </modal>

    <footer class="footer">
      <select v-model="selectedPageSize.value" @change="onChange">
        <option
          v-for="option in paginationOptions"
          :value="option.value"
          :key="option.value"
        >
          {{ option.name }}
        </option>
      </select>
      <span style="display: inline-block; margin-left: 25px">
        共 {{ showingRecords }}/{{ totalCount }} 條記錄
      </span>
      <button type="button" class="nextPage" @click="goToNextPage">
        &#8594;
      </button>
      <span class="pages"> {{ pageNum }}/{{ totalPages }} </span>
      <button type="button" class="prevPage" @click="goToPrevPage">
        &#8592;
      </button>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DeployPanel",
  data() {
    return {
      selectedVersion: 0,
      searchTicket: "",
      selectedPageSize: {
        name: "10 條顯示列數",
        value: 10,
      },
      paginationOptions: [
        {
          name: "10 條顯示列數",
          value: 10,
        },
        {
          name: "25 條顯示列數",
          value: 25,
        },
        {
          name: "50 條顯示列數",
          value: 50,
        },
        {
          name: "100 條顯示列數",
          value: 100,
        },
      ],
      pageNum: 1,
      pageSize: 10,
      totalPages: 1,
      totalCount: 1,
      showingRecords: 1,
      ticketErrorMsg: "",
      isTicketValid: false,
    };
  },
  created() {
    this.$store.dispatch("getDeployableVersions", this.getPayload());
  },
  computed: {
    ...mapGetters([
      "project",
      "isConfirmDeployModalOpen",
      "currentVersion",
      "deployableVersions",
      "deployableVersionsPage",
    ]),
  },
  methods: {
    onDeploy(version) {
      this.selectedVersion = version;
      this.$store.commit("setIsConfirmDeployModalOpen", true);
    },
    confirmDeploy() {
      if (this.currentVersion) {
        this.$store.dispatch("updateProductionVersion", {
          version: this.selectedVersion,
          payload: this.getPayload(),
        });
      }
    },
    cancel() {
      this.$store.commit("setIsConfirmDeployModalOpen", false);
    },
    onModalClose() {
      this.$store.commit("setIsConfirmDeployModalOpen", false);
    },
    searchByTicket() {
      this.$store.dispatch("getDeployableVersions", {
        ...this.getPayload(),
        searchTicket: this.searchTicket,
      });
    },
    getPayload() {
      return {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      };
    },
    onChange() {
      this.pageSize = this.selectedPageSize.value;
      this.pageNum = 1;
      this.$store.dispatch("getDeployableVersions", {
        ...this.getPayload(),
        searchTicket: this.searchTicket,
      });
    },
    goToPrevPage() {
      if (this.pageNum > 1) {
        this.pageNum -= 1;
        this.$store.dispatch("getDeployableVersions", {
          ...this.getPayload(),
          searchTicket: this.searchTicket,
        });
      }
    },
    goToNextPage() {
      if (this.pageNum < this.totalPages) {
        this.pageNum += 1;
        console.log(this.searchTicket);
        this.$store.dispatch("getDeployableVersions", {
          ...this.getPayload(),
          searchTicket: this.searchTicket,
        });
      }
    },
    handleInput(searchTicket) {
      this.isTicketValid = /^[a-zA-Z0-9-]+$/.test(searchTicket);
      this.ticketErrorMsg = !this.isTicketValid ? "不可輸入特殊符號" : "";
    },
  },
  watch: {
    project() {
      this.pageNum = 1;
      this.totalPages = 1;
      this.$store.dispatch("getDeployableVersions", this.getPayload());
      this.searchTicket = "";
    },
    isConfirmDeployModalOpen() {
      if (this.isConfirmDeployModalOpen) {
        this.$modal.show("deploy");
      } else {
        this.$modal.hide("deploy");
      }
    },
  },
  beforeUpdate() {
    this.totalCount = this.deployableVersionsPage[0];
    this.showingRecords = this.deployableVersions.length;
    this.totalPages =
      this.deployableVersionsPage.totalPages === 0
        ? 1
        : this.deployableVersionsPage[1];
  },
};
</script>

<style>
.deploy-versions-container {
  max-width: 1024px;
  margin: 0 auto;

  .deploy-version-item {
    display: flex;
    align-items: center;
    padding: 8px 12px;

    & + & {
      /* margin-top: 12px; */
      border-bottom: 1px black solid;
    }

    &.header {
      .deploy-version,
      .deploy-version-changes,
      .deploy-action {
        font-weight: bold;
      }

      border-bottom: 1px solid black;
    }

    .deploy-version {
      flex: 0 0 100px;
    }

    .deploy-version-changes {
      flex: 1;
    }

    .deploy-action {
      flex: 0 0 100px;
      text-align: center;
    }

    .version-change-ticket {
      & + & {
        margin-top: 4px;
      }
    }
  }

  .deploy-btn {
    background-color: #21ba45;
    color: #fff;
    box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
    padding: 0.5rem 1.5rem;
    border: none;
    border-radius: 0.3rem;
    cursor: pointer;
    &:hover {
      background-color: #16ab39;
    }

    &[disabled] {
      background-color: #6c757d;
    }
  }
}

.modal-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .modal-title {
    font-weight: bold;
    font-size: 24px;
    padding: 0 12px;
  }

  .modal-body {
    text-align: center;
    font-size: 18px;
    flex: 1;
    padding: 6px 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    .confirm-deploy-title {
      font-weight: bold;
    }
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    padding: 6px 12px;

    .button {
      margin-left: 16px;
      color: #fff;
      box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
      padding: 0.5rem 1.5rem;
      border: none;
      border-radius: 0.3rem;
      cursor: pointer;

      &.confirm-btn {
        background-color: #21ba45;
        &:hover {
          background-color: #16ab39;
        }
      }

      &.cancel-btn {
        background-color: #a5673f;
        &:hover {
          background-color: #975b33;
        }
      }
    }
  }
}
</style>
